// idToSlug / slugToId now live in @breath-lab/core (single source of truth shared
// with the OG card generator and mobile share links). Imported for local use in
// the path helpers below, and re-exported so the existing ~20 web call sites keep
// importing from './routes' unchanged.
import { idToSlug, slugToId } from '@breath-lab/core';
export { idToSlug, slugToId };

export const ROUTES = {
  home: '/',
  loggedInHome: '/home',
  welcome: '/welcome',
  breathworks: '/breathworks',
  breathworkDetail: '/breathworks/:id',
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  authAction: '/auth/action',
  activity: '/activity',
  achievements: '/achievements',
  profile: '/profile',
  breathworkConfigure: '/breathworks/:id/configure',
  breathworkPlay: '/breathworks/:id/play',
  breathworkSuccess: '/breathworks/:id/success',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  activityDetail: '/activity/:workoutId',
  activitySessionDetail: '/activity/session/:sessionId',
  achievementDetail: '/achievements/:achievementId',
  journeys: '/journeys',
  journeyDetail: '/journeys/:id',
  contact: '/contact',
  upgrade: '/upgrade',
  pricing: '/pricing',
  designSystem: '/design-system',
  designSystemTypography: '/design-system/typography',
  designSystemColorPalette: '/design-system/color-palette',
  designSystemComponents: '/design-system/components',
} as const;

export function breathworkDetailPath(id: string): string {
  return `/breathworks/${idToSlug(id)}`;
}

export function breathworkConfigurePath(id: string): string {
  return `/breathworks/${idToSlug(id)}/configure`;
}

export function breathworkPlayPath(id: string): string {
  return `/breathworks/${idToSlug(id)}/play`;
}

export function breathworkSuccessPath(id: string): string {
  return `/breathworks/${idToSlug(id)}/success`;
}

export function activityDetailPath(workoutId: string): string {
  return `/activity/${workoutId}`;
}

export function activitySessionDetailPath(sessionId: string): string {
  return `/activity/session/${sessionId}`;
}

export function achievementDetailPath(achievementId: string): string {
  return `/achievements/${idToSlug(achievementId)}`;
}

export function journeyDetailPath(id: string): string {
  return `/journeys/${idToSlug(id)}`;
}

export function welcomePath(): string {
  return '/welcome';
}

export function upgradePath(): string {
  return ROUTES.upgrade;
}

export function pricingPath(): string {
  return ROUTES.pricing;
}
